module.exports = __webpack_public_path__ + "img/prestige.a96e96d1.jpg";